import { useEffect, useState } from 'react';

/**
 * A live `mm:ss` string counting down to `deadlineAt` (an ISO timestamp),
 * re-rendered every second. Returns `null` when there is no deadline or it has
 * already passed — so a caller can branch on "still ticking" vs "expired".
 *
 * Shared by the match check-in surfaces (tournament detail + queue sheet): both
 * put a live countdown on the "Play" button while the confirmation window runs.
 */
export function useCountdown(deadlineAt: string | null | undefined): string | null {
  const [, tick] = useState(0);
  useEffect(() => {
    if (!deadlineAt) return;
    const id = window.setInterval(() => tick((n) => n + 1), 1000);
    return () => window.clearInterval(id);
  }, [deadlineAt]);

  if (!deadlineAt) return null;
  const ms = new Date(deadlineAt).getTime() - Date.now();
  if (!Number.isFinite(ms) || ms <= 0) return null;
  const total = Math.floor(ms / 1000);
  return `${Math.floor(total / 60)}:${String(total % 60).padStart(2, '0')}`;
}
